import styled from "styled-components";

export const Container = styled.div`
  max-width: 552px;
`;

export const Title = styled.h1`
  font-weight: normal;
  color: #292929;
  margin: 0;
`;
export const Description = styled.p`
  line-height: 2;
  margin: 1.6em 0 2.4em;
  color: #888888;
  font-size: 0.875rem;
`;
